import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[catalogazione-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CatalogazioneValidatorDirective, multi: true }]
})
export class CatalogazioneValidatorDirective implements Validator {

  validate(c: FormControl): ValidationErrors {
    // console.log('catalogazione-validator', c.value);
    const isValid = c.value;
    const message = {
      'catalogazione': {
        'message': 'Specificare una catalogazione'
      }
    };
    return isValid ? null : message;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/catalogazione-validator.directive.ts